export const engagementReportBuilder2AppGroupIdSegmentIdentities =
  "/engagement/report_builder_2/:app_group_id/segment_identities";
